import { useEffect, useState } from "react";
import { Tabs } from "../../../components/common/Tabs"
import { useTheme } from "../../../components/hooks/useTheme";
import { CurrentType } from "../../../enum/CurrentType";
import { Dates } from "./Dates2";
import { getTimeZones } from "../../../services/Timezone";
import { getBranches } from "../../../services/branch";
import moment from "moment";
import { getLocations } from "../../../services/location";
import { Vehicles } from "./Vehicles2";
import { Extras } from "./Extras2";
import { Customer } from "./Customer2";
import { Confirm } from "./Confirm2";
import { Payments } from "./Payments2";
import { Checkout } from "./Checkout2";
import { Agreement } from "./Agreement2";
import { Checkin } from "./Checkin2";
import { Changes } from "./Changes2";
import { Summary } from "./Summary2";
import { getExtrasByBranchIdAndVehicleClassId } from "../../../services/extra";
import { getDiscountsByBranchId } from "../../../services/discount";
import { getReservationAdditionalChargesReportByReservationId } from "../../../services/reservationAdditionalCharge";
import { useLocation, useNavigate } from "react-router-dom";
import { getReservationAdditionalDriverReportByReservationId } from "../../../services/reservationAdditionalDriver";
import { getReservationPaymentsByReservationId } from "../../../services/Payment";
import { getReservationRefundsByReservationId } from "../../../services/refund";
import { delete_comment, getCommentsReportByAttributeAndAttributeId, post_comment } from "../../../services/comment";
import { branchTimezone, calulatedDiscountValue } from "../../../utils/summaryCalculation";
import useAuth from "../../../components/hooks/useAuth";
import DateAndTimeChange from "./DateAndTimeChange2";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import { Button } from "@mui/material";
import AddComments from "../../AddComments";
import useDelete from "../../../components/hooks/useDelete";
import { getCarsWithReservation, getTheAvailableCarsOFBranch } from "../../../services/availableCars";
import { getFileUploads } from "../../../services/appFileUpload";
import { getCreditCardOfCustomer } from "../../../services/creditCard";
import colorConfigs from "../../../configs/colorConfigs";
import { getCustomer } from "../../../services/customer";
import { getPaymentRequestsByReservationId } from "../../../services/PaymentRequest";
import RentalAndRecieptButton from "./RentalAndRecieptButton";
import { getQuoteDiscountsByQuoteId } from "../../../services/quoteDiscount";
import { getQuoteAdditionalChargesByQuoteId } from "../../../services/quoteAdditionalCharge";
import useConfirm from "../../../components/hooks/useConfirm";
import { calculate, dateChange, driverChange, getReservationSummary, vehicleClassChange } from "../../../services/rental";
import useGeneral from "../../../components/hooks/useGeneral";
import { SummaryWithReservation } from "./SummaryWithReservation";
import { getVehicle } from "../../../services/Vehicle";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";


const AddReservationTabs = [
    {
        label: "Dates",
    },
    {
        label: "Vehicles",
    },
    {
        label: "Extras",
    },
    {
        label: "Customer",
    },
    {
        label: "Confirm",
    },

]

const EditReservationTabs = [
    {
        label: "Dates",
    },
    {
        label: "Vehicles",
    },
    {
        label: "Extras",
    },
    {
        label: "Customer",
    },
    {
        label: "Confirm",
    },
    {
        label: "Payments",
    },
    {
        label: "Check Out",
    },
    {
        label: "Agreement",
    },
    {
        label: "Check in",
    },
    {
        label: "Changes",
    },

]

type TabType = {
    label: string
}

type CommentType = {
    id: number;
    attributeName: string;
    attributeId: string;
    notes: string;
    userName: string;
    createdDate: string;
};

type TenTabLayoutProps = {
    currentType: CurrentType;
    setCurrentType: (value: CurrentType) => void;
    _primaryKey: number;
    data: any;
    quoteId?: string | number;
}

export const TenTabLayout = ({
    currentType,
    setCurrentType,
    _primaryKey,
    data,
    quoteId
}: TenTabLayoutProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search)
    const customerIdFromCustomer = queryParams?.get('customerId') ?? 0;
    const navigate = useNavigate();

    const { themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { dateFormat }: any = useGeneral();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();

    //Block Tab Condition
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [tabs, setTabs] = useState<TabType[]>(AddReservationTabs);
    const [activeTabLabel, setActiveTabLabel] = useState<string>(tabs[0].label);


    const [isCompletedOrCancelled, setIsCompletedOrCancelled] = useState<boolean>(false);
    const [summaryData, setSummaryData] = useState<any | null>(null);
    const [refreshTheSummary, setRefreshTheSummary] = useState<boolean>(true);
    const [primaryKey, setPrimaryKey] = useState<number>(0);
    const [isFirstTime, setIsFirstTime] = useState<boolean>(false);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);


    //Block Tab Condition
    const [isdateText, setIsDateText] = useState<boolean>(false);
    const [isCustomerSelected, setIsCustomerSelected] = useState<boolean>(false);
    const [isCheckout, setIsCheckout] = useState<boolean>(false);
    const [isCheckin, setIsCheckin] = useState<boolean>(false);


    //Date
    const currentDate = new Date();

    const [timezoneOptions, setTimezoneOptions] = useState<any[]>([]);
    const [timezoneOptionsIsLoaded, setTimezoneOptionsIsLoaded] = useState<boolean>(false);
    const [isBranchSetForFirstTime, setIsBranchSetForFirstTime] = useState<boolean>(false);
    const [branches, setBranches] = useState<any[]>([]);
    const [locations, setLocations] = useState<any[]>([]);
    const [branchId, setBranchId] = useState<number>(0);
    const [pickupDate, setPickupDate] = useState<string>(currentDate.toISOString().split("T")[0]);
    const [pickupTime, setPickupTime] = useState<string>("");
    const [returnDate, setReturnDate] = useState<string>(new Date(currentDate.setDate(currentDate.getDate() + 1)).toISOString().split("T")[0]);
    const [returnTime, setReturnTime] = useState<string>("");
    const [pickupLocationId, setPickupLocationId] = useState<number>(0);
    const [returnLocationId, setReturnLocationId] = useState<number>(0);
    const [walkInCustomer, setWalkInCustomer] = useState<boolean>(true);

    const [formattedCreatedAt, setFormattedCreatedAt] = useState<string>("");
    const [pickupLocationOptionsOfParticularBranch, setPickupLocationOptionsOfParticularBranch] = useState<any[]>([]);
    const [returnLocationOptionsOfParticularBranch, setReturnLocationOptionsOfParticularBranch] = useState<any[]>([]);
    const [locationOpenHourOfParticularBranch, setLocationOpenHourOfParticularBranch] = useState<any[]>([]);

    const [dateAndTimeBox, setDateAndTimeBox] = useState<boolean>(false);
    const [dateAlertMessage, setDateAlertMessage] = useState<string>("")


    //Cars
    const [availableVehicle, setAvailableVehicle] = useState<any[]>([]);
    const [vehicleClassId, setVehicleClassId] = useState<number>(0);
    const [selectedVehicleClass, setSelectedVehiclesClass] = useState<any | null>(null);
    const [isFirsTimeLoaded, setIsFirstTimeLoaded] = useState<boolean>(true);
    const [manualRateChange, setManualRateChange] = useState<any>({
        wasRateManuallyChanged: false,
        hourlyRate: 0,
        dailyRate: 0,
        weeklyRate: 0,
        monthlyRate: 0
    });

    //Extras
    const [extraValue, setExtraValue] = useState<any[]>([]);
    const [checkExtraValue, setCheckExtraValue] = useState<any[]>([]);
    const [reservationAdditionalCharge, setReservationAdditionalCharge] = useState<any[]>([]);
    const [reservationAdditionalChargeDataIsLoaded, setReservationAdditionalChargeDataIsLoaded] = useState<boolean>(false);
    const [isExtraValueIsLoaded, setIsExtraValueIsLoaded] = useState<boolean>(false);
    const [loadedBranchId, setLoadedBranchId] = useState<number>(0);
    const [refreshTheAdjustment, setRefreshTheAdjustment] = useState<boolean>(true);
    const [locationFeeAmount, setLocationFeeAmount] = useState<number>(0);
    const [taxAmount, setTaxAmount] = useState<number>(0);
    const [mandatoryAdditionalChargesAmount, setMandatoryAdditionalChargesAmount] = useState<number>(0);
    const [governmentTaxAmount, setGovernmentTaxAmount] = useState<number>(0);

    //Discount
    const [discountOptions, setDiscountOptions] = useState<any[]>([]);
    const [appliedDiscountList, setAppliedDiscountList] = useState<any[]>([
        {
            id: 0,
            discountId: 0,
            discountDefinition: "",
            discountType: "Percentage",
            discountAmount: 0.00,
            discount: 0.00,
            manualDiscount: false,
            discountApplied: false
        },
        {
            id: 0,
            discountId: 0,
            discountDefinition: "Manual Discount",
            discountType: "Amount",
            discountAmount: 0.00,
            discount: 0.00,
            manualDiscount: true,
            discountApplied: false
        }
    ]);

    //Customer
    const [localAddress, setLocalAddress] = useState<string>("");
    const [customerId, setCustomerId] = useState<number>(0);
    const [additionalDriver, setAdditionalDriver] = useState<any[]>([]);
    const [customersUpdate, setCustomersUpdate] = useState<boolean>(true);
    const [hideToolbar, setHideToolbar] = useState<boolean>(false);
    const [customerData, setCustomerData] = useState<any | null>(null);


    //Confirm
    const [confirmSignatureURL, setConfirmSignatureURL] = useState<any | null>();


    //Comments
    const [refreshTheComment, setRefreshTheComment] = useState<boolean>(true);
    const [saveCommentsValue, setSaveCommentsValue] = useState([]);
    const [comments, setComments] = useState<string>("");


    //Payments
    const [allPaymentList, setAllPaymentList] = useState<any[]>([]);
    const [paymentUpdate, setPaymentUpdate] = useState<boolean>(true);
    const [refundList, setRefundList] = useState<any[]>([]);
    const [refundUpdate, setRefundUpdate] = useState<boolean>(true);
    const [creditCardList, setCreditCardList] = useState<any[]>([]);
    const [allPaymentRequestList, setAllPaymentRequestList] = useState<any[]>([]);
    const [paymentRequestUpdate, setPaymentRequestUpdate] = useState<boolean>(true);

    //Chechout
    const [bookedVehicleData, setBookedVehicleData] = useState<any | null>(null);
    const [signatureURL, setSignatureURL] = useState<any | null>();
    const [initialsURL, setInitialsURL] = useState<any | null>();
    const [fileChange, setFileChange] = useState<boolean>(true);
    const [checkOutFiles, setCheckOutFiles] = useState<any[]>([]);
    const [vehicleReplacementCheckOutFiles, setVehicleReplacementCheckOutFiles] = useState<any[]>([]);
    const [isVehicleSelected, setIsVehicleSelected] = useState<boolean>(false);


    //CheckIn
    const [checkInFiles, setCheckInFiles] = useState<any[]>([]);
    const [vehicleReplacementCheckInFiles, setVehicleReplacementCheckInFiles] = useState<any[]>([]);


    //Security Deposit
    const [securityDepositAmount, setSecurityDepositAmount] = useState<number>(0.0);
    const [securityDepositAmountPaid, setSecurityDepositAmountPaid] = useState<number>(0.0);
    const [wasSecurityDepositManuallyChanged, setWasSecurityDepositManuallyChanged] = useState<boolean>(false);

    const UpdateTimezone = branchTimezone(formattedCreatedAt);

    useEffect(() => {
        if (currentType === CurrentType.EDIT) {
            setTabs(EditReservationTabs);
        } else {
            setTabs(AddReservationTabs);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentType])

    const handleTabChange = (index: number, tab: any, isSelected: boolean) => {
        switch (index) {
            case 0:
                setActiveIndex(index);
                setActiveTabLabel(tab?.label);
                setIsVehicleSelected(false);
                setIsCustomerSelected(false);
                setIsCheckout(false);
                setIsCheckin(false);
                break;
            case 1:
                if ((branchId && pickupDate && pickupDate && pickupTime && returnTime && pickupLocationId && returnLocationId) || isSelected) {
                    setActiveIndex(index);
                    setActiveTabLabel(tab?.label);
                    setIsDateText(false);
                } else {
                    setIsDateText(true);
                }
                setIsVehicleSelected(false);
                setIsCustomerSelected(false);
                setIsCheckout(false);
                setIsCheckin(false);
                break;
            case 2:
                if (vehicleClassId > 0 || isSelected) {
                    setActiveIndex(index);
                    setActiveTabLabel(tab?.label);
                    setIsDateText(false);
                    setIsVehicleSelected(false);
                } else {
                    setIsVehicleSelected(true);
                }
                setIsCustomerSelected(false);
                setIsCheckout(false);
                setIsCheckin(false);
                break;
            case 3:
                if (vehicleClassId > 0) {
                    setActiveIndex(index);
                    setActiveTabLabel(tab?.label);
                    setIsVehicleSelected(false);
                } else {
                    setIsVehicleSelected(true);
                }
                setIsCustomerSelected(false);
                setIsCheckout(false);
                setIsCheckin(false);
                break;
            case 4:
                if (vehicleClassId > 0) {
                    if (customerId || isSelected) {
                        setActiveIndex(index);
                        setActiveTabLabel(tab?.label);
                        setIsCustomerSelected(false);
                    } else {
                        setIsCustomerSelected(true);
                    }
                    setIsVehicleSelected(false);
                } else {
                    setIsVehicleSelected(true);
                }
                setIsCheckout(false);
                setIsCheckin(false);
                break;
            case 5:
                if (vehicleClassId > 0) {
                    setActiveIndex(index);
                    setActiveTabLabel(tab?.label);
                    setIsVehicleSelected(false);
                } else {
                    setIsVehicleSelected(true);
                }

                break;
            case 6:
                if (vehicleClassId > 0) {
                    setActiveIndex(index);
                    setActiveTabLabel(tab?.label);
                    setIsVehicleSelected(false);
                } else {
                    setIsVehicleSelected(true);
                }

                setIsCheckout(false);
                setIsCheckin(false);
                break;
            case 7:
                setActiveIndex(index);
                setActiveTabLabel(tab?.label);
                setIsCheckout(false);
                setIsCheckin(false);
                break;
            case 8:
                if (summaryData?.status === "Open") {
                    setIsCheckin(true);
                } else {
                    if (securityDepositAmount === 0) {
                        setActiveIndex(index);
                        setActiveTabLabel(tab?.label);
                        setIsCheckin(false);
                    } else {
                        setIsCheckin(false);
                    }
                }
                break;
            case 9:
                setActiveIndex(index);
                setActiveTabLabel(tab?.label);
                setIsCheckin(false);
                break;
        }
    }

    useEffect(() => {
        if (!timezoneOptionsIsLoaded) {
            getTimeZones(tenantId)
                .then(res => {
                    const data = res?.map((item: any) => ({
                        value: item?.id,
                        label: item?.name
                    }));
                    setTimezoneOptions(data);
                    setTimezoneOptionsIsLoaded(true);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setTimezoneOptions([]);
                    setTimezoneOptionsIsLoaded(true);
                    handleTenantError(error);
                });
        }

        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getBranches(tenantId)
            .then(data => {
                setBranches(data);
                if (currentType === CurrentType.ADD) {
                    if (data?.length <= 0) {
                        setBranchId(0);

                        if (currentType === CurrentType.ADD) {
                            const timeData = new Date().toLocaleString("en-US", {
                                timeZone: moment.tz.guess()
                            });

                            setPickupTime(moment(timeData).format('HH:mm'));
                            setReturnTime(moment(timeData).format('HH:mm'));
                        }
                        return;
                    }

                    setBranchId(data[0]?.id || 0);
                }
                handleTenantError(null);
            })
            .catch((error) => {
                setBranches([]);
                setBranchId(0);

                if (currentType === CurrentType.ADD) {
                    const timeData = new Date().toLocaleString("en-US", {
                        timeZone: moment.tz.guess()
                    });

                    setPickupTime(moment(timeData).format('HH:mm'));
                    setReturnTime(moment(timeData).format('HH:mm'));
                }
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (branches && timezoneOptionsIsLoaded && !isBranchSetForFirstTime) {
            const branch = branches?.find((item: any) => item?.id === branchId);
            if (branch) {
                const offset = moment.tz(moment.tz.guess()).format('Z');
                const defaultTimeZone = `(GMT ${offset}) ${moment.tz.guess()} ${moment.tz(moment.tz.guess()).zoneAbbr()}`;

                const selectedBranchTimezone = branch?.timeZone;
                if (selectedBranchTimezone) {
                    if (parseInt(selectedBranchTimezone) > 0) {
                        const timeZoneData = timezoneOptions?.find((item: any) => item.value === parseInt(selectedBranchTimezone));
                        if (timeZoneData) {
                            if (currentType === CurrentType.ADD) {
                                const timeData = new Date().toLocaleString("en-US", {
                                    timeZone: timeZoneData?.label?.split(" ")[2]
                                });

                                setPickupTime(moment(timeData).format('HH:mm'));
                                setReturnTime(moment(timeData).format('HH:mm'));

                                const currentTimezoneDate = new Date(branchTimezone(timeZoneData?.label));
                                setPickupDate(moment(currentTimezoneDate).format("YYYY-MM-DD"));
                                setReturnDate(moment(currentTimezoneDate).add(1, 'day').format("YYYY-MM-DD"));
                            }
                            setFormattedCreatedAt(timeZoneData?.label);
                        } else {
                            if (currentType === CurrentType.ADD) {
                                const timeData = new Date().toLocaleString("en-US", {
                                    timeZone: moment.tz.guess()
                                });

                                setPickupTime(moment(timeData).format('HH:mm'));
                                setReturnTime(moment(timeData).format('HH:mm'));

                                const currentTimezoneDate = new Date(branchTimezone(defaultTimeZone));
                                setPickupDate(moment(currentTimezoneDate).format("YYYY-MM-DD"));
                                setReturnDate(moment(currentTimezoneDate).add(1, 'day').format("YYYY-MM-DD"));
                            }

                            setFormattedCreatedAt(defaultTimeZone);
                        }
                    } else {
                        if (currentType === CurrentType.ADD) {
                            const timeData = new Date().toLocaleString("en-US", {
                                timeZone: moment.tz.guess()
                            });

                            setPickupTime(moment(timeData).format('HH:mm'));
                            setReturnTime(moment(timeData).format('HH:mm'));

                            const currentTimezoneDate = new Date(branchTimezone(defaultTimeZone));
                            setPickupDate(moment(currentTimezoneDate).format("YYYY-MM-DD"));
                            setReturnDate(moment(currentTimezoneDate).add(1, 'day').format("YYYY-MM-DD"));
                        }

                        setFormattedCreatedAt(defaultTimeZone);
                    }
                } else {
                    setFormattedCreatedAt(defaultTimeZone);
                }

                setIsBranchSetForFirstTime(true);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branchId, branches, timezoneOptionsIsLoaded]);

    useEffect(() => {
        getLocations(tenantId)
            .then(data => {
                setLocations(data);
                handleTenantError(null);
            })
            .catch(error => {
                setLocations([]);
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const firstTimeUploadTheAvailableVehicle = (
        inputBranchId: number,
        inputPickupDate: string,
        inputPickupTime: string,
        inputReturnDate: string,
        inputReturnTime: string,
        inputVehicleClassId: number
    ) => {
        let latestPickup = moment().format('YYYY-MM-DDTHH:mm');
        let latestReturn = moment().format('YYYY-MM-DDTHH:mm');
        if (inputPickupDate) latestPickup = moment(`${inputPickupDate}T${inputPickupTime}`).format('YYYY-MM-DDTHH:mm');
        if (inputReturnDate) latestReturn = moment(`${inputReturnDate}T${inputReturnTime}`).format('YYYY-MM-DDTHH:mm');

        const fetchFun = primaryKey <= 0 
                ? getCarsWithReservation(primaryKey, latestPickup, latestReturn, inputBranchId, tenantId)
                : getTheAvailableCarsOFBranch(latestPickup, latestReturn, inputBranchId, tenantId)
            
            fetchFun
            .then((data) => {
                setAvailableVehicle(data);

                const selectedVehicleClass = data?.find((item: any) => item?.vehicleClassId === inputVehicleClassId);

                if (selectedVehicleClass) {
                    setVehicleClassId(selectedVehicleClass?.vehicleClassId);
                    setSelectedVehiclesClass(selectedVehicleClass);
                }

                setIsFirstTimeLoaded(false);

                setPleaseWaitPopup(false);
                handleTenantError(null);
            })
            .catch((error) => {
                setConfirmData({
                    title: 'Warning',
                    summary: error.response.data,
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setConfirmPopup(true);

                setPleaseWaitPopup(false);
                setAvailableVehicle([]);
                setVehicleClassId(0);
                setSelectedVehiclesClass(null);
                handleTenantError(error);
            });
    }

    useEffect(() => {
        if (branchId && pickupDate && pickupTime && returnDate && returnTime && isFirsTimeLoaded && primaryKey <= 0 && currentType !== CurrentType.ADD_FROM_QUOTES) {
            firstTimeUploadTheAvailableVehicle(
                branchId,
                pickupDate,
                pickupTime,
                returnDate,
                returnTime,
                vehicleClassId
            );
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branchId, pickupDate, pickupTime, returnDate, returnTime]);

    const goToNextStep = (index: number) => {
        if (index === 5) {
            if (tabs.length < 6) {
                setTabs(EditReservationTabs);
                setActiveIndex(index)
                setActiveTabLabel(EditReservationTabs[index].label);
                handleTabChange(index, tabs[index], true);
            }
        } else {
            setActiveIndex(index)
            setActiveTabLabel(tabs[index].label);
            handleTabChange(index, tabs[index], true);
        }
    };

    const getDataFromDates = (
        inputPickupDate: string,
        inputPickupTime: string,
        inputReturnDate: string,
        inputReturnTime: string,
        alertMessage: string,
        inputBranchId: number,
        inputPickupLocationId: number,
        inputReturnLocationId: number,
        inputWalkInCustomer: boolean
    ) => {
        setPickupDate(inputPickupDate);
        setPickupTime(inputPickupTime);
        setReturnDate(inputReturnDate);
        setReturnTime(inputReturnTime);
        setDateAlertMessage(alertMessage);
        setBranchId(inputBranchId);
        setPickupLocationId(inputPickupLocationId);
        setReturnLocationId(inputReturnLocationId);
        setWalkInCustomer(inputWalkInCustomer);

        if (primaryKey > 0) {
            let latestPickup = moment().format('YYYY-MM-DDTHH:mm');
            let latestReturn = moment().format('YYYY-MM-DDTHH:mm');
            if (inputPickupDate && inputPickupTime) latestPickup = moment(`${inputPickupDate}T${inputPickupTime}`).format('YYYY-MM-DDTHH:mm');
            if (inputReturnDate && inputReturnTime) latestReturn = moment(`${inputReturnDate}T${inputReturnTime}`).format('YYYY-MM-DDTHH:mm');

            dateChange(
                {
                    pickupDate: latestPickup,
                    returnDate: latestReturn,
                    branchId: inputBranchId,
                    pickupLocationId: inputPickupLocationId,
                    returnLocationId: inputReturnLocationId,
                    walkInCustomer: inputWalkInCustomer
                },
                primaryKey,
                auth?.id,
                tenantId
            )
                .then(() => {
                    setRefreshTheSummary(true);
                    handleTenantError(null);
                })
                .catch(error => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                })
        } else {
            triggerSummaryCalculation(
                inputPickupDate,
                inputPickupTime,
                inputReturnDate,
                inputReturnTime,
                inputBranchId,
                inputPickupLocationId,
                inputReturnLocationId,
                inputWalkInCustomer,
                mandatoryAdditionalChargesAmount,
                locationFeeAmount,
                taxAmount,
                governmentTaxAmount,
                appliedDiscountList
            );
        }

        if (vehicleClassId <= 0 || inputBranchId !== branchId) {
            setPleaseWaitPopup(true);

            firstTimeUploadTheAvailableVehicle(
                inputBranchId,
                inputPickupDate,
                inputPickupTime,
                inputReturnDate,
                inputPickupTime,
                vehicleClassId
            );
        }
    };

    const getDataFromDatesSummaryPopup = (
        inputPickupDate: string,
        inputPickupTime: string,
        inputReturnDate: string,
        inputReturnTime: string,
        alertMessage: string
    ) => {
        setPickupDate(inputPickupDate);
        setPickupTime(inputPickupTime);
        setReturnDate(inputReturnDate);
        setReturnTime(inputReturnTime);
        setDateAlertMessage(alertMessage);

        if (primaryKey > 0) {
            let latestPickup = moment().format('YYYY-MM-DDTHH:mm');
            let latestReturn = moment().format('YYYY-MM-DDTHH:mm');
            if (inputPickupDate && inputPickupTime) latestPickup = moment(`${inputPickupDate}T${inputPickupTime}`).format('YYYY-MM-DDTHH:mm');
            if (inputReturnDate && inputReturnTime) latestReturn = moment(`${inputReturnDate}T${inputReturnTime}`).format('YYYY-MM-DDTHH:mm');

            dateChange(
                {
                    pickupDate: latestPickup,
                    returnDate: latestReturn,
                    branchId: branchId,
                    pickupLocationId: pickupLocationId,
                    returnLocationId: returnLocationId,
                    walkInCustomer: walkInCustomer
                },
                primaryKey,
                auth?.id,
                tenantId
            )
                .then(() => {
                    setRefreshTheSummary(true);
                    handleTenantError(null);
                })
                .catch(error => {
                    setPleaseWaitPopup(false);
                    setConfirmData({
                        title: 'Warning',
                        summary: error.response.data,
                        confirmBtn: 'Ok',
                        isConfirm: (callback: any) => {
                            callback();
                        }
                    });

                    setConfirmPopup(true);
                    handleTenantError(error);
                })
        } else {
            triggerSummaryCalculation(
                inputPickupDate,
                inputPickupTime,
                inputReturnDate,
                inputReturnTime,
                branchId,
                pickupLocationId,
                returnLocationId,
                walkInCustomer,
                mandatoryAdditionalChargesAmount,
                locationFeeAmount,
                taxAmount,
                governmentTaxAmount,
                appliedDiscountList
            );
        }

        if (vehicleClassId <= 0) {
            setPleaseWaitPopup(true);

            firstTimeUploadTheAvailableVehicle(
                branchId,
                inputPickupDate,
                inputPickupTime,
                inputReturnDate,
                inputPickupTime,
                vehicleClassId
            );
        }
    };

    const getDataFromCars = (
        vehicleClassId: number,
        selectedVehicleClass: any
    ) => {
        setVehicleClassId(vehicleClassId);
        setSelectedVehiclesClass(selectedVehicleClass);

        if (primaryKey > 0) {
            setPleaseWaitPopup(true)

            vehicleClassChange(
                primaryKey,
                vehicleClassId,
                auth?.id,
                tenantId
            )
                .then(() => {
                    setRefreshTheSummary(true);
                    handleTenantError(null);
                })
                .catch(error => {
                    setPleaseWaitPopup(false)
                    handleTenantError(error);
                })
        }
    };


    const getDataFromUpdateOrder = (
        locationFeePercentage: number,
        taxPercentage: number,
        governmentTaxPercentage: number,
        discountList: any[]
    ) => {
        if (primaryKey <= 0) {
            triggerSummaryCalculation(
                pickupDate,
                pickupTime,
                returnDate,
                returnTime,
                branchId,
                pickupLocationId,
                returnLocationId,
                walkInCustomer,
                mandatoryAdditionalChargesAmount,
                locationFeePercentage,
                taxPercentage,
                governmentTaxPercentage,
                discountList
            );

            setLocationFeeAmount(locationFeePercentage);
            setTaxAmount(taxPercentage);
            setGovernmentTaxAmount(governmentTaxPercentage);
        }
    };

    useEffect(() => {
        if (summaryData?.status === "Completed" || summaryData?.status === "Cancelled" || summaryData?.status === "Cancelled Paid") {
            setIsCompletedOrCancelled(true);
        } else {
            setIsCompletedOrCancelled(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [summaryData?.status])

    const getDataFromExtras = (updatedCheckExtraValue: any[]) => {
        setCheckExtraValue(updatedCheckExtraValue);
    };

    useEffect(() => {
        if (branchId > 0 && vehicleClassId > 0) {
            setIsExtraValueIsLoaded(false);
            getExtrasByBranchIdAndVehicleClassId(branchId, vehicleClassId, tenantId)
                .then((data) => {
                    setExtraValue(data);
                    setIsExtraValueIsLoaded(true);
                    setRefreshTheAdjustment(true);
                    setLoadedBranchId(branchId);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setExtraValue([]);
                    setIsExtraValueIsLoaded(true);
                    setRefreshTheAdjustment(true);
                    setLoadedBranchId(branchId);
                    handleTenantError(error);
                });
        } else {
            setIsExtraValueIsLoaded(false);
            setRefreshTheAdjustment(true);
            setExtraValue([]);
            setLoadedBranchId(-1);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branchId, vehicleClassId]);

    useEffect(() => {
        if (branchId > 0) {
            getDiscountsByBranchId(branchId, tenantId)
                .then(data => {
                    setDiscountOptions(data);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setDiscountOptions([]);
                    handleTenantError(error);
                });
        } else {
            setDiscountOptions([]);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branchId]);

    useEffect(() => {
        if (_primaryKey) {
            setPrimaryKey(_primaryKey);
            setActiveIndex(0);
            setActiveTabLabel(tabs[0]?.label)
            setRefreshTheSummary(true);
            setCustomersUpdate(true);
            setPaymentUpdate(true);
            setPaymentRequestUpdate(true);
            setRefundUpdate(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_primaryKey])

    useEffect(() => {
        if (customerId) {
            getCustomer(customerId, tenantId)
                .then((data) => {
                    setCustomerData(data);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setCustomerData(null);
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId]);

    useEffect(() => {
        if (Number(customerIdFromCustomer) > 0) {
            setCustomerId(Number(customerIdFromCustomer));
        }
    }, [customerIdFromCustomer])

    useEffect(() => {
        if (primaryKey > 0 && refreshTheSummary) {
            setPleaseWaitPopup(true);

            getReservationSummary(primaryKey, tenantId)
                .then(data => {
                    setRefreshTheAdjustment(true);
                    setIsFirstTime(true);

                    setPickupDate(data.pickupDate?.split("T")[0]);
                    setReturnDate(data.returnDate?.split("T")[0]);
                    setPickupTime(data.pickupDate?.split("T")[1]);
                    setReturnTime(data.returnDate?.split("T")[1]);

                    setBranchId(data.branchId);
                    setPickupLocationId(data.pickupLoationId);
                    setReturnLocationId(data.returenLoationId);

                    setVehicleClassId(data.vehicleClassId);
                    setWalkInCustomer(data.walkInCustomer);

                    setLocalAddress(data.localAddress);
                    setCustomerId(data?.customerId);

                    const couponDiscount = data?.reservationDiscount?.find((item: any) => item?.discountId > 0 && !item?.manualDiscount);
                    const manualDiscount = data?.reservationDiscount?.find((item: any) => item?.manualDiscount);

                    let couponDiscountValue = 0.00;
                    if (couponDiscount) {
                        couponDiscountValue = calulatedDiscountValue(couponDiscount?.discountAmount, couponDiscount?.discountType, data?.totalBasePriceBeforeDiscount);
                    }

                    let manualDiscountValue = 0.00;
                    if (manualDiscount) {
                        manualDiscountValue = calulatedDiscountValue(manualDiscount?.discountAmount, manualDiscount?.discountType, data?.totalBasePriceBeforeDiscount);
                    }

                    setAppliedDiscountList([
                        {
                            id: couponDiscount ? couponDiscount?.id : 0,
                            discountId: couponDiscount ? couponDiscount?.discountId : 0,
                            discountDefinition: couponDiscount ? couponDiscount?.discountDefinition : 0,
                            discountType: couponDiscount ? couponDiscount?.discountType : "Percentage",
                            discountAmount: couponDiscount ? couponDiscount?.discountAmount : 0.00,
                            discount: couponDiscountValue,
                            manualDiscount: false,
                            discountApplied: couponDiscount ? true : false
                        },
                        {
                            id: manualDiscount ? manualDiscount?.id : 0,
                            discountId: 0,
                            discountDefinition: manualDiscount ? manualDiscount?.discountDefinition : 0,
                            discountType: manualDiscount ? manualDiscount?.discountType : "Amount",
                            discountAmount: manualDiscount ? manualDiscount?.discountAmount : 0.00,
                            discount: manualDiscountValue,
                            manualDiscount: true,
                            discountApplied: manualDiscount ? true : false
                        }
                    ]);

                    setSecurityDepositAmount(data?.securityDepositAmount - data?.securityDepositAmountPaid > 0 ? data?.securityDepositAmount - data?.securityDepositAmountPaid : 0);
                    setSecurityDepositAmountPaid(data?.securityDepositAmountPaid);

                    setIsVehicleSelected(parseInt(data.vehicleClassId) <= 0);

                    if (data?.mandatoryAdditionalChargesAmount && data?.mandatoryAdditionalChargesAmount > 0) {
                        setMandatoryAdditionalChargesAmount(data?.mandatoryAdditionalChargesAmount);
                    } else {
                        setMandatoryAdditionalChargesAmount(0);
                    }

                    if (data?.locationFeePercentage && data?.locationFeePercentage > 0) {
                        setLocationFeeAmount(data?.locationFeePercentage);
                    } else {
                        setLocationFeeAmount(0);
                    }

                    if (data?.taxPercentage && data?.taxPercentage > 0) {
                        setTaxAmount(data?.taxPercentage);
                    } else {
                        setTaxAmount(0);
                    }

                    if (data?.governmentTaxPercentage && data?.governmentTaxPercentage > 0) {
                        setGovernmentTaxAmount(data?.governmentTaxPercentage);
                    } else {
                        setGovernmentTaxAmount(0);
                    }

                    setSummaryData(data);
                    setRefreshTheSummary(false);
                    setCurrentType(CurrentType.EDIT);

                    firstTimeUploadTheAvailableVehicle(
                        data?.branchId,
                        data.pickupDate?.split("T")[0],
                        data.pickupDate?.split("T")[1],
                        data.returnDate?.split("T")[0],
                        data.returnDate?.split("T")[1],
                        data?.vehicleClassId
                    );
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [primaryKey, refreshTheSummary]);

    useEffect(() => {
        if (summaryData?.vehicleId > 0) {
            getVehicle(summaryData?.vehicleId, tenantId)
                .then((data) => {
                    setBookedVehicleData(data);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setBookedVehicleData(null);
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [summaryData])

    //Edit the Reservation
    useEffect(() => {
        if (primaryKey > 0 && customersUpdate) {
            getReservationAdditionalDriverReportByReservationId(primaryKey, tenantId)
                .then(data => {
                    setAdditionalDriver(data);
                    setCustomersUpdate(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setCustomersUpdate(false);
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customersUpdate, summaryData]);

    useEffect(() => {
        if (primaryKey > 0 && paymentUpdate) {
            getReservationPaymentsByReservationId(primaryKey, tenantId)
                .then((data) => {
                    setAllPaymentList(data);
                    setPaymentUpdate(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPaymentUpdate(false);
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentUpdate, summaryData]);

    useEffect(() => {
        if (primaryKey > 0 && paymentRequestUpdate) {
            getPaymentRequestsByReservationId(primaryKey, tenantId)
                .then((data) => {
                    setAllPaymentRequestList(data);
                    setPaymentRequestUpdate(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setAllPaymentRequestList([]);
                    setPaymentRequestUpdate(false);
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentRequestUpdate, summaryData]);

    useEffect(() => {
        if (primaryKey > 0 && refundUpdate) {
            getReservationRefundsByReservationId(primaryKey, tenantId)
                .then((data) => {
                    setRefundUpdate(false);
                    setRefundList(data);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setRefundUpdate(false);
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refundUpdate, summaryData]);

    useEffect(() => {
        if (isExtraValueIsLoaded && refreshTheAdjustment && branchId && branchId === loadedBranchId) {
            setReservationAdditionalChargeDataIsLoaded(() => false);
            if (primaryKey > 0) {
                getReservationAdditionalChargesReportByReservationId(primaryKey, tenantId)
                    .then((data) => {
                        setReservationAdditionalCharge(data);
                        const updatedExtraData = extraValue?.map((item: any) => {
                            const additionalCharges = item?.additionalCharges?.map((value: any) => {
                                const addedAdditionalCharge = data?.find((addedValue: any) => addedValue?.additionalChargeByBranchId === value?.additionalChargeBranchId);

                                return {
                                    ...value,
                                    quantity: addedAdditionalCharge ? addedAdditionalCharge?.quantity : 1,
                                    basePrice: addedAdditionalCharge ? addedAdditionalCharge?.basePrice : 0,
                                    isChecked: addedAdditionalCharge ? true : false,
                                    reservationAdditionalId: addedAdditionalCharge ? addedAdditionalCharge?.id : 0
                                }
                            });

                            return {
                                ...item,
                                additionalCharges
                            };
                        });

                        setExtraValue(updatedExtraData);
                        setReservationAdditionalChargeDataIsLoaded(true);
                        setRefreshTheAdjustment(false);
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        setReservationAdditionalChargeDataIsLoaded(true)
                        setRefreshTheAdjustment(false);
                        handleTenantError(error);
                    });
            } else {
                if (currentType !== CurrentType.ADD_FROM_QUOTES) {
                    setTimeout(() => {
                        setReservationAdditionalChargeDataIsLoaded(true);
                    }, 0);
                }
                setRefreshTheAdjustment(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [summaryData, isExtraValueIsLoaded, refreshTheAdjustment, branchId, loadedBranchId]);

    useEffect(() => {
        if (primaryKey > 0) {
            getCreditCardOfCustomer(summaryData?.customerId, tenantId)
                .then(data => {
                    setCreditCardList(data)
                    handleTenantError(null);
                })
                .catch(error => {
                    setCreditCardList([]);
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [summaryData])

    useEffect(() => {
        if (primaryKey > 0) {
            getCommentsReportByAttributeAndAttributeId("Reservation", primaryKey, tenantId)
                .then(data => {
                    setSaveCommentsValue(data?.reverse());
                    setRefreshTheComment(false);
                    handleTenantError(null);
                })
                .catch(error => {
                    setRefreshTheComment(false);
                    handleTenantError(error);
                });
        } else {
            setSaveCommentsValue([]);
            setRefreshTheComment(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshTheComment, primaryKey]);

    useEffect(() => {
        if (primaryKey > 0 && summaryData && fileChange) {
            getFileUploads("Reservation", primaryKey?.toString(), tenantId)
                .then((data) => {
                    setConfirmSignatureURL(data?.find((item: any) => item?.tabName === "Confirm"));
                    setSignatureURL(data?.find((item: any) => item?.tabName === "Signature"));
                    setInitialsURL(data?.find((item: any) => item?.tabName === "Initials"));

                    setCheckOutFiles(data?.filter((item: any) => item?.tabName === "Checkout"));
                    setCheckInFiles(data?.filter((item: any) => item?.tabName === "Checkin"));

                    const replacementCheckOutFile = data?.filter((item: any) => item?.tabName?.startsWith("Checkout-VehicleReplacement-"));
                    setVehicleReplacementCheckOutFiles(replacementCheckOutFile);

                    const replacementCheckInFile = data?.filter((item: any) => item?.tabName?.startsWith("Checkin-VehicleReplacement-"));
                    setVehicleReplacementCheckInFiles(replacementCheckInFile);
                    setFileChange(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setFileChange(false);
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [summaryData, fileChange]);


    useEffect(() => {
        if (data && currentType === CurrentType.ADD_FROM_QUOTES) {
            setPleaseWaitPopup(true);

            setIsFirstTime(true);
            setBranchId(data?.branchId);
            setVehicleClassId(data?.vehicleClassId);
            setPickupLocationId(data?.pickupLoationId);
            setReturnLocationId(data?.returenLoationId);
            setPickupDate(data?.pickupDate?.split("T")[0]);
            setPickupTime(data?.pickupDate?.split("T")[1]?.slice(0, 5));
            setReturnDate(data?.returenDate?.split("T")[0]);
            setReturnTime(data?.returenDate?.split("T")[1]?.slice(0, 5));
            setIsDateText(false);
            setCustomerId(data?.customerId);
            setIsVehicleSelected(parseInt(data?.vehicleClassId) <= 0);
            setSecurityDepositAmount(data?.securityDepositAmount || 0);

            if (data?.mandatoryAdditionalChargesAmount && data?.mandatoryAdditionalChargesAmount > 0) {
                setMandatoryAdditionalChargesAmount(data?.mandatoryAdditionalChargesAmount);
            } else {
                setMandatoryAdditionalChargesAmount(0);
            }

            if (data?.locationFeePercentage && data?.locationFeePercentage > 0) {
                setLocationFeeAmount(data?.locationFeePercentage);
            } else {
                setLocationFeeAmount(0);
            }

            if (data?.taxPercentage && data?.taxPercentage > 0) {
                setTaxAmount(data?.taxPercentage);
            } else {
                setTaxAmount(0);
            }

            if (data?.governmentTaxPercentage && data?.governmentTaxPercentage > 0) {
                setGovernmentTaxAmount(data?.governmentTaxPercentage);
            } else {
                setGovernmentTaxAmount(0);
            }

            setRefreshTheAdjustment(true);

            triggerSummaryCalculation(
                data?.pickupDate?.split("T")[0],
                data?.pickupDate?.split("T")[1]?.slice(0, 5),
                data?.returenDate?.split("T")[0],
                data?.returenDate?.split("T")[1]?.slice(0, 5),
                data?.branchId,
                data?.pickupLoationId,
                data?.returenLoationId,
                walkInCustomer,
                data?.mandatoryAdditionalChargesAmount,
                data?.locationFeePercentage,
                data?.taxPercentage,
                data?.governmentTaxPercentage,
                appliedDiscountList
            );

            firstTimeUploadTheAvailableVehicle(
                data?.branchId,
                data?.pickupDate?.split("T")[0],
                data?.pickupDate?.split("T")[1]?.slice(0, 5),
                data?.returenDate?.split("T")[0],
                data?.returenDate?.split("T")[1]?.slice(0, 5),
                data?.vehicleClassId
            );

            setActiveIndex(2);

            setManualRateChange(() => ({
                wasRateManuallyChanged: true,
                hourlyRate: data?.hourlyRate,
                dailyRate: data?.dailyRate,
                weeklyRate: data?.weeklyRate,
                monthlyRate: data?.monthlyRate
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, currentType])

    useEffect(() => {
        if (data && currentType === CurrentType.ADD_FROM_QUOTES) {
            getQuoteDiscountsByQuoteId(parseInt(data?.id), tenantId)
                .then((res) => {
                    const couponDiscount = res?.find((item: any) => item?.discountId > 0 && !item?.manualDiscount);
                    const manualDiscount = res?.find((item: any) => item?.manualDiscount);

                    let couponDiscountValue = 0.00;
                    if (couponDiscount) {
                        couponDiscountValue = calulatedDiscountValue(couponDiscount?.discountAmount, couponDiscount?.discountType, data?.rackPrice);
                    }

                    let manualDiscountValue = 0.00;
                    if (manualDiscount) {
                        manualDiscountValue = calulatedDiscountValue(manualDiscount?.discountAmount, manualDiscount?.discountType, data?.rackPrice);
                    }

                    setAppliedDiscountList([
                        {
                            id: couponDiscount ? couponDiscount?.id : 0,
                            discountId: couponDiscount ? couponDiscount?.discountId : 0,
                            discountDefinition: couponDiscount ? couponDiscount?.discountDefinition : 0,
                            discountType: couponDiscount ? couponDiscount?.discountType : "Percentage",
                            discountAmount: couponDiscount ? couponDiscount?.discountAmount : 0.00,
                            discount: couponDiscountValue,
                            manualDiscount: false,
                            discountApplied: couponDiscount ? true : false
                        },
                        {
                            id: manualDiscount ? manualDiscount?.id : 0,
                            discountId: 0,
                            discountDefinition: manualDiscount ? manualDiscount?.discountDefinition : 0,
                            discountType: manualDiscount ? manualDiscount?.discountType : "Amount",
                            discountAmount: manualDiscount ? manualDiscount?.discountAmount : 0.00,
                            discount: manualDiscountValue,
                            manualDiscount: true,
                            discountApplied: manualDiscount ? true : false
                        }
                    ]);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setAppliedDiscountList([
                        {
                            id: 0,
                            discountId: 0,
                            discountDefinition: "",
                            discountType: "Percentage",
                            discountAmount: 0.00,
                            discount: 0.00,
                            manualDiscount: false,
                            discountApplied: false
                        },
                        {
                            id: 0,
                            discountId: 0,
                            discountDefinition: "Manual Discount",
                            discountType: "Amount",
                            discountAmount: 0.00,
                            discount: 0.00,
                            manualDiscount: true,
                            discountApplied: false
                        }
                    ]);
                    handleTenantError(error);
                });

            // setRefreshDiscontAppliedList(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, currentType])

    useEffect(() => {
        if (isExtraValueIsLoaded && data && currentType === CurrentType.ADD_FROM_QUOTES && branchId && branchId === loadedBranchId) {
            setReservationAdditionalChargeDataIsLoaded(false);
            getQuoteAdditionalChargesByQuoteId(data?.id, tenantId)
                .then((res) => {
                    setReservationAdditionalCharge(res);
                    const updatedExtraData = extraValue?.map((item: any) => {
                        const additionalCharges = item?.additionalCharges?.map((value: any) => {
                            const addedAdditionalCharge = res?.find((addedValue: any) => addedValue?.additionalChargeByBranchId === value?.additionalChargeBranchId);

                            return {
                                ...value,
                                quantity: addedAdditionalCharge ? addedAdditionalCharge?.quantity : 1,
                                basePrice: addedAdditionalCharge ? addedAdditionalCharge?.basePrice : 0,
                                isChecked: addedAdditionalCharge ? true : false,
                                reservationAdditionalId: addedAdditionalCharge ? addedAdditionalCharge?.id : 0
                            }
                        });

                        return {
                            ...item,
                            additionalCharges
                        };
                    });

                    setExtraValue(updatedExtraData);
                    setReservationAdditionalChargeDataIsLoaded(true);
                    setRefreshTheAdjustment(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setReservationAdditionalChargeDataIsLoaded(true)
                    setRefreshTheAdjustment(false);
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, currentType, isExtraValueIsLoaded, branchId, loadedBranchId])


    const getDataFromCustomer = (customerId: number, localAddress: string) => {
        setLocalAddress(localAddress);
        setCustomerId(customerId);

        getCustomer(customerId, tenantId)
            .then((data) => {
                setCustomerData(data);
                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                setCustomerData(null);
                setPleaseWaitPopup(false);
                console.error(error);
            });

        if (primaryKey > 0) {
            setPleaseWaitPopup(true);

            driverChange(
                primaryKey,
                customerId,
                true,
                auth?.id,
                tenantId
            )
                .then(() => {
                    setRefreshTheSummary(true);
                    setCustomersUpdate(true);
                    handleTenantError(null);
                })
                .catch(error => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                })
        }
    };

    const onRateChangeBeforeBookingConfirm = (type: string, amount: number) => {
        switch (type) {
            case "Hourly":
                setManualRateChange({
                    wasRateManuallyChanged: true,
                    hourlyRate: amount,
                    dailyRate: summaryData?.dailyRate,
                    weeklyRate: summaryData?.weeklyRate,
                    monthlyRate: summaryData?.monthlyRate
                });
                break;
            case "Daily":
                setManualRateChange({
                    wasRateManuallyChanged: true,
                    hourlyRate: summaryData?.hourlyRate,
                    dailyRate: amount,
                    weeklyRate: summaryData?.weeklyRate,
                    monthlyRate: summaryData?.monthlyRate
                });
                break;
            case "Weekly":
                setManualRateChange({
                    wasRateManuallyChanged: true,
                    hourlyRate: summaryData?.hourlyRate,
                    dailyRate: summaryData?.dailyRate,
                    weeklyRate: amount,
                    monthlyRate: summaryData?.monthlyRate
                });
                break;
            case "Monthly":
                setManualRateChange({
                    wasRateManuallyChanged: true,
                    hourlyRate: summaryData?.hourlyRate,
                    dailyRate: summaryData?.dailyRate,
                    weeklyRate: summaryData?.weeklyRate,
                    monthlyRate: amount
                });
                break;
        }
    }

    const triggerSummaryCalculation = (
        inputPickupDate: string,
        inputPickupTime: string,
        inputReturnDate: string,
        inputReturnTime: string,
        inputBranchId: number,
        inputPickupLocationId: number,
        inputReturnLocationId: number,
        inputWalkInCustomer: boolean,
        mandatoryAdditionalChargesAmount: number,
        locationFeeAmount: number,
        taxAmount: number,
        governmentTaxAmount: number,
        inputDiscountList: any[]
    ) => {
        let additionalValue: any[] = [];
        if (checkExtraValue?.length > 0) {
            checkExtraValue?.forEach((item: any,) => {
                additionalValue = [...additionalValue, ...item?.additionalCharges];
            });
        }

        let latestPickup = moment().format('YYYY-MM-DDTHH:mm');
        let latestReturn = moment().format('YYYY-MM-DDTHH:mm');
        if (inputPickupDate && inputPickupTime) latestPickup = moment(`${inputPickupDate}T${inputPickupTime}`).format('YYYY-MM-DDTHH:mm');
        if (inputReturnDate && inputReturnTime) latestReturn = moment(`${inputReturnDate}T${inputReturnTime}`).format('YYYY-MM-DDTHH:mm');

        calculate(
            {
                pickupDate: latestPickup,
                returnDate: latestReturn,
                branchId: inputBranchId ?? 0,
                pickupLocationId: inputPickupLocationId ?? 0,
                returnLocationId: inputReturnLocationId ?? 0,
                isWalkInCustomer: inputWalkInCustomer,
                vehicleClassId: vehicleClassId ?? 0,
                wasSecurityDepositManuallyChanged: wasSecurityDepositManuallyChanged,
                securityDepositAmount: securityDepositAmount,
                reservationAdditionalChargeDto: additionalValue?.map((item: any) => (
                    {
                        additionalChargeByBranchId: item?.additionalChargeBranchId,
                        quantity: item?.quantity,
                        basePrice: item?.basePrice
                    }
                )),
                reservationDiscountDto: inputDiscountList
                    ?.filter((item: any) => item?.discountApplied)
                    ?.map(item => (
                        {
                            discountId: item?.discountId,
                            discountDefinition: item?.discountDefinition,
                            discountType: item?.discountType,
                            discountAmount: item?.discountAmount,
                            discount: item?.discount,
                            manualDiscount: item?.manualDiscount
                        }
                    ))
                ,
                mandatoryAdditionalChargesAmount: mandatoryAdditionalChargesAmount,
                locationFeePercentage: locationFeeAmount ?? 0,
                taxPercentage: taxAmount ?? 0,
                governmentTaxPercentage: governmentTaxAmount ?? 0,
                customerId: customerId ?? 0,
                localAddress: "",
                fileUploadDataDto: [],
                ...manualRateChange
            },
            tenantId
        )
            .then(data => {
                setSummaryData(data);
                setPleaseWaitPopup(false);

                const couponDiscount = data?.reservationDiscountDto?.find((item: any) => item?.discountId > 0 && !item?.manualDiscount);
                const manualDiscount = data?.reservationDiscountDto?.find((item: any) => item?.manualDiscount);

                let couponDiscountValue = 0.00;
                if (couponDiscount) {
                    couponDiscountValue = calulatedDiscountValue(couponDiscount?.discountAmount, couponDiscount?.discountType, data?.totalBasePriceBeforeDiscount);
                }

                let manualDiscountValue = 0.00;
                if (manualDiscount) {
                    manualDiscountValue = calulatedDiscountValue(manualDiscount?.discountAmount, manualDiscount?.discountType, data?.totalBasePriceBeforeDiscount);
                }

                setAppliedDiscountList([
                    {
                        id: couponDiscount ? couponDiscount?.id : 0,
                        discountId: couponDiscount ? couponDiscount?.discountId : 0,
                        discountDefinition: couponDiscount ? couponDiscount?.discountDefinition : 0,
                        discountType: couponDiscount ? couponDiscount?.discountType : "Percentage",
                        discountAmount: couponDiscount ? couponDiscount?.discountAmount : 0.00,
                        discount: couponDiscountValue,
                        manualDiscount: false,
                        discountApplied: couponDiscount ? true : false
                    },
                    {
                        id: manualDiscount ? manualDiscount?.id : 0,
                        discountId: 0,
                        discountDefinition: manualDiscount ? manualDiscount?.discountDefinition : 0,
                        discountType: manualDiscount ? manualDiscount?.discountType : "Amount",
                        discountAmount: manualDiscount ? manualDiscount?.discountAmount : 0.00,
                        discount: manualDiscountValue,
                        manualDiscount: true,
                        discountApplied: manualDiscount ? true : false
                    }
                ]);
                handleTenantError(null);
            })
            .catch((error) => {
                setConfirmData({
                    title: 'Warning',
                    summary: error.response.data,
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setConfirmPopup(true);

                setSummaryData(null);
                setPleaseWaitPopup(false);
                handleTenantError(error);
            })
    }

    //calculate the summary without reservation
    useEffect(() => {
        if (primaryKey <= 0 && (currentType === CurrentType.ADD_FROM_QUOTES || currentType === CurrentType.ADD)) {
            setPleaseWaitPopup(true);

            triggerSummaryCalculation(
                pickupDate,
                pickupTime,
                returnDate,
                returnTime,
                branchId,
                pickupLocationId,
                returnLocationId,
                walkInCustomer,
                mandatoryAdditionalChargesAmount,
                locationFeeAmount,
                taxAmount,
                governmentTaxAmount,
                appliedDiscountList
            );
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        vehicleClassId,
        wasSecurityDepositManuallyChanged,
        securityDepositAmount,
        customerId,
        checkExtraValue,
        manualRateChange
    ])

    const saveComment = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!comments?.trim()) {
            return;
        }
        setPleaseWaitPopup(true);

        post_comment({
            attributeName: "Reservation",
            attributeId: primaryKey,
            notes: comments?.trim(),
            userId: auth?.id,
            createdDate: new Date(UpdateTimezone).toLocaleString()
        }, auth?.id, tenantId)
            .then(() => {
                setComments("");
                setRefreshTheComment(true);
                setPleaseWaitPopup(false);
                handleTenantError(null);
            })
            .catch(error => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
            });
    };

    const deleteTheComment = async (id: number) => {
        setDeleteData({
            tilte: 'Delete',
            summary: 'Are you sure you want to delete this comment?',
            confirmBtn: 'Yes',
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                delete_comment(id, auth?.id, tenantId)
                    .then(() => {
                        setPleaseWaitPopup(false);
                        setSaveCommentsValue(saveCommentsValue?.filter((item: any) => item.id !== id));
                        handleTenantError(null);
                    })
                    .catch(error => {
                        setPleaseWaitPopup(false);
                        handleTenantError(error);
                    });

                callback();
            }
        });

        setDeletePopup(true);
    }


    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen relative h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2 flex items-center justify-between">
                        <Tabs tabs={tabs} onChange={(index, tab) => handleTabChange(index, tab, false)} activeIndex={activeIndex} />

                        {
                            primaryKey > 0 && (
                                <RentalAndRecieptButton
                                    reservationId={primaryKey}
                                    isVehicleReplaced={summaryData?.isVehicleReplaced}
                                    bookingNumber={summaryData?.bookingNumber}
                                    customerName={summaryData?.customerName || ""}
                                    customerEmail={summaryData?.customerEmail || ""}
                                />
                            )
                        }
                    </div>
                    {
                        isdateText && (
                            <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                Please Fill Every details
                            </p>
                        )
                    }

                    {
                        isVehicleSelected && (
                            <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                You have to select a vehicle
                            </p>
                        )
                    }

                    {
                        isCustomerSelected && (
                            <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                Please select a customer
                            </p>
                        )
                    }

                    {
                        isCheckout && securityDepositAmount > 0 && (
                            <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                Please clear the security deposit amount
                            </p>
                        )
                    }

                    {
                        isCheckin && (
                            <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                This action is not allowed for Open reservation status
                            </p>
                        )
                    }

                    {
                        dateAlertMessage && (
                            <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                {dateAlertMessage}
                            </p>
                        )
                    }

                    {
                        activeIndex !== 0 && (
                            <>
                                {
                                    (primaryKey > 0 && securityDepositAmount > 0) && (
                                        <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                            The Security Deposit hasn't been released yet.
                                        </p>
                                    )
                                }

                                {
                                    (
                                        primaryKey > 0 && Number(summaryData?.outstandingBalance) !== 0) && (
                                        <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                            The Reservation has an outstanding balance of $
                                            {Number(summaryData?.outstandingBalance)?.toFixed(2)}
                                        </p>
                                    )
                                }
                            </>
                        )
                    }

                    <div className={`p-2 border-b ${themeStyles.main.borderColor}`}>
                        <div className="mt-4">
                            <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>
                                {
                                    currentType === CurrentType.ADD || currentType === CurrentType.ADD_FROM_QUOTES ?
                                        "New Reservation"
                                        : (
                                            <>
                                                <span
                                                    style={{ color: "var(--app-link-color)" }}
                                                    className="underline cursor-pointer"
                                                    onClick={() => {
                                                        navigate(`/contacts/customers/editcustomer?id=${summaryData?.customerId}`)
                                                    }}
                                                >
                                                    {summaryData?.customerName ? summaryData?.customerName : ""}
                                                </span>
                                                {summaryData?.bookingNumber ? (" - " + summaryData?.bookingNumber) : ""}
                                            </>
                                        )
                                }
                            </h2>
                        </div>
                    </div>
                    <div>

                        <div className="flex justify-between">
                            {
                                activeIndex === 0 && (
                                    <div className={`${primaryKey > 0 ? "w-[65%] mt-8" : "w-full"}`}>
                                        <Dates
                                            goToNextPage={(page) => goToNextStep(page)}
                                            getDataFromDate={(
                                                pickupDate,
                                                pickupTime,
                                                returnDate,
                                                returnTime,
                                                alertMessage,
                                                branchId,
                                                pickupLocation,
                                                returnLocation,
                                                walkInCustomer
                                            ) =>
                                                getDataFromDates(
                                                    pickupDate,
                                                    pickupTime,
                                                    returnDate,
                                                    returnTime,
                                                    alertMessage,
                                                    branchId,
                                                    pickupLocation,
                                                    returnLocation,
                                                    walkInCustomer
                                                )
                                            }
                                            preferredDateFormat={dateFormat}
                                            branches={branches}
                                            locations={locations}
                                            popUpPickupDate={pickupDate}
                                            popUpReturnDate={returnDate}
                                            popUpPickupTime={pickupTime}
                                            popUpReturnTime={returnTime}
                                            selectBranchId={branchId}
                                            currentType={currentType}
                                            _pickupLocationId={pickupLocationId}
                                            _returnLocationId={returnLocationId}
                                            _walkInCustomer={walkInCustomer}
                                            pickupLocationOptionsOfParticularBranch={pickupLocationOptionsOfParticularBranch}
                                            setPickupLocationOptionsOfParticularBranch={setPickupLocationOptionsOfParticularBranch}
                                            returnLocationOptionsOfParticularBranch={returnLocationOptionsOfParticularBranch}
                                            setReturnLocationOptionsOfParticularBranch={setReturnLocationOptionsOfParticularBranch}
                                            locationOpenHourOfParticularBranch={locationOpenHourOfParticularBranch}
                                            setLocationOpenHourOfParticularBranch={setLocationOpenHourOfParticularBranch}
                                            setLocationFeeAmount={setLocationFeeAmount}
                                            setTaxAmount={setTaxAmount}
                                            setMandatoryAdditionalChargesAmount={setMandatoryAdditionalChargesAmount}
                                            setGovernmentTaxAmount={setGovernmentTaxAmount}
                                            formattedCreatedAt={formattedCreatedAt}
                                            setFormattedCreatedAt={setFormattedCreatedAt}
                                            timezoneOptions={timezoneOptions}
                                            selectedVehicleClassId={vehicleClassId}
                                            setVehicleClassId={setVehicleClassId}
                                            setSelectedVehiclesClass={setSelectedVehiclesClass}
                                            setAvailableVehicle={setAvailableVehicle}
                                            reservationId={primaryKey}
                                            setPleaseWait={setPleaseWaitPopup}
                                        />
                                    </div>
                                )
                            }

                            {
                                activeIndex === 1 && (
                                    <div className="w-[65%] mt-4">
                                        <Vehicles
                                            goToNextPage={(page) => goToNextStep(page)}
                                            getDataFromCars={(vehicleClassId, selectedVehicleClass) =>
                                                getDataFromCars(vehicleClassId, selectedVehicleClass)
                                            }
                                            availableVehicle={availableVehicle}
                                            selectedVehiclesClasses={selectedVehicleClass}
                                            summaryData={summaryData}
                                            isCompletedOrCancelled={isCompletedOrCancelled}
                                            reservationId={primaryKey}
                                        />
                                    </div>
                                )
                            }

                            {
                                <div className={`w-[55%] mt-5 ${activeIndex === 2 ? "block" : "hidden"}`}>
                                    <Extras
                                        goToNextPage={(page) => goToNextStep(page)}
                                        getDataFromExtras={(extraValue) =>
                                            getDataFromExtras(extraValue)
                                        }
                                        getDataFromUpdateOrder={(locationFeePercentage, taxPercentage, governmentTaxPercentage, discountList) =>
                                            getDataFromUpdateOrder(locationFeePercentage, taxPercentage, governmentTaxPercentage, discountList)
                                        }
                                        summaryData={summaryData}
                                        refreshTheSummary={() => setRefreshTheSummary(true)}
                                        refreshTheAdjustment={() => setRefreshTheAdjustment(true)}
                                        extraValueData={extraValue}
                                        reservationAdditionalChargeDataIsLoaded={reservationAdditionalChargeDataIsLoaded}
                                        branchId={branchId}
                                        formattedCreatedAt={formattedCreatedAt}
                                        vehicleClassId={vehicleClassId}
                                        pickupDate={pickupDate}
                                        pickupTime={pickupTime}
                                        returnDate={returnDate}
                                        returnTime={returnTime}
                                        pickupLocation={pickupLocationId}
                                        returnLocation={returnLocationId}
                                        discountOptions={discountOptions}
                                        appliedDiscountList={appliedDiscountList}
                                        securityDepositAmount={securityDepositAmount}
                                        isCompletedOrCancelled={isCompletedOrCancelled}
                                        reservationId={primaryKey}
                                        locationFeeAmount={locationFeeAmount}
                                        taxAmount={taxAmount}
                                        governmentTaxAmount={governmentTaxAmount}
                                        setLocationFeeAmount={setLocationFeeAmount}
                                        setTaxAmount={setTaxAmount}
                                        setGovernmentTaxAmount={setGovernmentTaxAmount}
                                        checkExtraValue={checkExtraValue}
                                        setPleaseWait={setPleaseWaitPopup}
                                    />
                                </div>
                            }

                            {
                                activeIndex === 3 && (
                                    <div className="w-[65%] mt-8">
                                        <Customer
                                            goToNextPage={(page) => goToNextStep(page)}
                                            getDataFromCustomer={(customerId, localAddress) =>
                                                getDataFromCustomer(customerId, localAddress)
                                            }
                                            selectedVehicleClass={selectedVehicleClass}
                                            formattedCreatedAt={formattedCreatedAt}
                                            preferredDateFormat={dateFormat}
                                            pickupDate={pickupDate}
                                            returnDate={returnDate}
                                            returnTime={returnTime}
                                            hideToolbar={hideToolbar}
                                            setHideToolbar={(hideToolbar) => setHideToolbar(hideToolbar)}
                                            customerPrimaryKey={customerId}
                                            isFirstTime={isFirstTime}
                                            setIsFirstTime={setIsFirstTime}
                                            isCompletedOrCancelled={isCompletedOrCancelled}
                                            currentPage={activeTabLabel}
                                            reservationId={primaryKey}
                                            summaryData={summaryData}
                                            setPleaseWaitPopup={setPleaseWaitPopup}
                                        />
                                    </div>
                                )
                            }

                            {
                                activeIndex === 4 && (
                                    <div className="w-[65%] mt-6">
                                        <Confirm
                                            goToNextPage={(page) => goToNextStep(page)}
                                            vehicleClassId={vehicleClassId}
                                            branchId={branchId}
                                            formattedCreatedAt={formattedCreatedAt}
                                            pickupDate={pickupDate}
                                            pickupTime={pickupTime}
                                            returnDate={returnDate}
                                            returnTime={returnTime}
                                            pickupLocation={pickupLocationId}
                                            returnLocation={returnLocationId}
                                            locations={locations}
                                            customerId={customerId}
                                            localAddress={localAddress}
                                            walkInCustomer={walkInCustomer}
                                            confirmSignatureURL={confirmSignatureURL}
                                            setConfirmSignatureURL={setConfirmSignatureURL}
                                            currentPage={activeTabLabel}
                                            reservationId={primaryKey}
                                            setPrimaryKey={(id) => setPrimaryKey(id)}
                                            checkExtraValue={checkExtraValue}
                                            selectedVehicleClass={selectedVehicleClass}
                                            securityDepositAmount={securityDepositAmount}
                                            wasSecurityDepositManuallyChanged={wasSecurityDepositManuallyChanged}
                                            appliedDiscountList={appliedDiscountList}
                                            isCompletedOrCancelled={isCompletedOrCancelled}
                                            customerData={customerData}
                                            currentType={currentType}
                                            quoteId={quoteId && quoteId}
                                            quotedata={data}
                                            summaryData={summaryData}
                                            manualRateChange={manualRateChange}
                                            refreshTheSummary={() => {
                                                setRefreshTheSummary(true);
                                                setRefreshTheAdjustment(true);
                                                setFileChange(true);
                                            }}
                                            setPleaseWait={setPleaseWaitPopup}
                                        />
                                    </div>
                                )
                            }

                            {
                                activeIndex === 5 && (
                                    <div className="w-[65%] mt-8">
                                        <Payments
                                            formattedCreatedAt={formattedCreatedAt}
                                            allPaymentList={allPaymentList}
                                            refreshThepayment={() => setPaymentUpdate(true)}
                                            allPaymentRequestList={allPaymentRequestList}
                                            refreshThePaymentRequest={() => setPaymentRequestUpdate(true)}
                                            refundList={refundList}
                                            refreshThRefund={() => setRefundUpdate(true)}
                                            discountOptions={discountOptions}
                                            appliedDiscountList={appliedDiscountList}
                                            securityDepositAmount={securityDepositAmount}
                                            extraValue={extraValue}
                                            isCompletedOrCancelled={isCompletedOrCancelled}
                                            getDataFromExtras={(extraValue) =>
                                                getDataFromExtras(extraValue)
                                            }
                                            refreshTheAdjustment={() => setRefreshTheAdjustment(true)}
                                            reservationId={primaryKey}
                                            preferredDateFormat={dateFormat}
                                            creditCardList={creditCardList}
                                            reservationAdditionalCharge={reservationAdditionalCharge}
                                            summaryData={summaryData}
                                            refreshTheSummary={() => setRefreshTheSummary(true)}
                                            setPleaseWait={setPleaseWaitPopup}
                                        />
                                    </div>
                                )
                            }

                            {
                                activeIndex === 6 && (
                                    <div className="w-[65%] mt-8">
                                        <Checkout
                                            goToNextPage={(page) => goToNextStep(page)}
                                            summaryData={summaryData}
                                            refreshTheSummary={() => setRefreshTheSummary(true)}
                                            availableVehicle={availableVehicle}
                                            additionalDriver={additionalDriver}
                                            refreshTheAdditionalDriver={() => setCustomersUpdate(true)}
                                            signatureURL={signatureURL}
                                            setSignatureURL={(value) => setSignatureURL(value)}
                                            initialsURL={initialsURL}
                                            setInitialsURL={(value) => setInitialsURL(value)}
                                            refreshTheAttachement={() => setFileChange(true)}
                                            formattedCreatedAt={formattedCreatedAt}
                                            securityDepositAmount={securityDepositAmount}
                                            vehicleClassId={vehicleClassId}
                                            setVehicleClassId={setVehicleClassId}
                                            setSelectedVehiclesClass={setSelectedVehiclesClass}
                                            bookedVehicleData={bookedVehicleData}
                                            setBookedVehicleData={setBookedVehicleData}
                                            pickupDate={pickupDate}
                                            returnDate={returnDate}
                                            returnTime={returnTime}
                                            isCompletedOrCancelled={isCompletedOrCancelled}
                                            pickupLocationOptions={locations}
                                            checkOutFiles={checkOutFiles}
                                            vehicleReplacementCheckOutFiles={vehicleReplacementCheckOutFiles}
                                            reservationId={primaryKey}
                                            preferredDateFormat={dateFormat}
                                            selectedVehicleClass={selectedVehicleClass}
                                            pleaseWaitPopup={pleaseWaitPopup}
                                            setPleaseWaitPopup={setPleaseWaitPopup}
                                        />
                                    </div>
                                )
                            }

                            {
                                activeIndex === 7 && (
                                    <div className="w-[65%] mt-8">
                                        <Agreement
                                            summaryData={summaryData}
                                            customerPhoneNumber={customerData?.phoneNumber}
                                            formattedCreatedAt={formattedCreatedAt}
                                            signatureURL={signatureURL}
                                            setSignatureURL={(value) => setSignatureURL(value)}
                                            initialsURL={initialsURL}
                                            setInitialsURL={(value) => setInitialsURL(value)}
                                            extraValue={extraValue}
                                            selectedVehicleClass={selectedVehicleClass}
                                            reservationAdditionalCharge={reservationAdditionalCharge}
                                            isCompletedOrCancelled={isCompletedOrCancelled}
                                            getDataFromExtras={(extraValue) =>
                                                getDataFromExtras(extraValue)
                                            }
                                            refreshTheSummary={() => setRefreshTheSummary(true)}
                                            refreshTheAdjustment={() => setRefreshTheAdjustment(true)}
                                            currentPage={activeTabLabel}
                                            locationOpenHourOfParticularBranch={locationOpenHourOfParticularBranch}
                                            availableVehicle={availableVehicle}
                                            locationOptions={locations}
                                            returnLocationOptionsOfParticularBranch={returnLocationOptionsOfParticularBranch}
                                            bookedVehicleData={bookedVehicleData}
                                            checkInFiles={checkInFiles}
                                            checkOutFiles={checkOutFiles}
                                            vehicleReplacementCheckOutFiles={vehicleReplacementCheckOutFiles}
                                            vehicleReplacementCheckInFiles={vehicleReplacementCheckInFiles}
                                            reservationId={primaryKey}
                                            refreshTheAttachement={() => setFileChange(true)}
                                            preferredDateFormat={dateFormat}
                                            setAvailableVehicle={setAvailableVehicle}
                                            setPleaseWaitPopup={setPleaseWaitPopup}
                                        />
                                    </div>
                                )
                            }

                            {
                                activeIndex === 8 && (
                                    <div className="w-[65%] mt-8">
                                        <Checkin
                                            goToNextPage={(page) => goToNextStep(page)}
                                            allPaymentList={allPaymentList}
                                            summaryData={summaryData}
                                            formattedCreatedAt={formattedCreatedAt}
                                            isCompletedOrCancelled={isCompletedOrCancelled}
                                            returnLocationOptions={locations}
                                            bookedVehicleData={bookedVehicleData}
                                            checkInFiles={checkInFiles}
                                            vehicleReplacementCheckInFiles={vehicleReplacementCheckInFiles}
                                            reservationId={primaryKey}
                                            securityDepositAmount={securityDepositAmount}
                                            refundList={refundList}
                                            preferredDateFormat={dateFormat}
                                            creditCardList={creditCardList}
                                            allPaymentRequestList={allPaymentRequestList}
                                            refreshTheSummary={() => setRefreshTheSummary(true)}
                                            refreshThepayment={() => setPaymentUpdate(true)}
                                            refreshThePaymentRequest={() => setPaymentRequestUpdate(true)}
                                            refreshThRefund={() => setRefundUpdate(true)}
                                            refreshTheAttachement={() => setFileChange(true)}
                                            setPleaseWaitPopup={setPleaseWaitPopup}
                                        />
                                    </div>
                                )
                            }

                            {
                                activeIndex === 9 && (
                                    <div className="w-[65%] mt-8">
                                        <Changes
                                            summaryData={summaryData}
                                            reservationAdditionalCharge={reservationAdditionalCharge}
                                            refreshTheSummary={() => setRefreshTheSummary(true)}
                                            refreshTheAdjustment={() => setRefreshTheAdjustment(true)}
                                            isCompletedOrCancelled={isCompletedOrCancelled}
                                            reservationId={primaryKey}
                                            locationFeeAmount={locationFeeAmount}
                                            taxAmount={taxAmount}
                                            governmentTaxAmount={governmentTaxAmount}
                                            setLocationFeeAmount={setLocationFeeAmount}
                                            setTaxAmount={setTaxAmount}
                                            setGovernmentTaxAmount={setGovernmentTaxAmount}
                                            setPleaseWait={setPleaseWaitPopup}
                                        />
                                    </div>
                                )
                            }

                            {
                                (primaryKey > 0 && summaryData) && (
                                    <div className="w-[30%] mt-8">
                                        <SummaryWithReservation
                                            reservationId={primaryKey}
                                            summaryData={summaryData}
                                            showDateAndTimeBox={() => setDateAndTimeBox(true)}
                                            selectedVehicleClass={selectedVehicleClass}
                                            appliedDiscountList={appliedDiscountList}
                                            securityDepositAmount={securityDepositAmount}
                                            updateSecurityDepositAmountToPaid={(value) => {
                                                setSecurityDepositAmount(value);
                                            }}
                                            setWasSecurityDepositManuallyChanged={setWasSecurityDepositManuallyChanged}
                                            refreshTheSummary={() => setRefreshTheSummary(true)}
                                            setPleaseWaitPopup={setPleaseWaitPopup}
                                        />
                                    </div>
                                )
                            }

                            {
                                (activeIndex !== 0 && primaryKey <= 0) && (
                                    <div className="w-[30%] mt-8">
                                        <Summary
                                            currentPage={activeIndex}
                                            reservationId={primaryKey}
                                            summaryData={summaryData}
                                            showDateAndTimeBox={() => setDateAndTimeBox(true)}
                                            selectedVehicleClass={selectedVehicleClass}
                                            securityDepositAmount={securityDepositAmount}
                                            securityDepositAmountPaid={securityDepositAmountPaid}
                                            updateSecurityDepositAmountToPaid={(value) => {
                                                setSecurityDepositAmount(value);
                                            }}
                                            setWasSecurityDepositManuallyChanged={setWasSecurityDepositManuallyChanged}
                                            refreshTheSummary={() => setRefreshTheSummary(true)}
                                            setPleaseWaitPopup={setPleaseWaitPopup}
                                            onRateChangeBeforeBookingConfirm={onRateChangeBeforeBookingConfirm}
                                        />
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    {
                        (
                            primaryKey > 0 && activeIndex !== 0) && (
                            <div className="w-full mt-4">
                                <div className="w-[50%]">
                                    <span className={`text-[14px] font-semibold mt-2 ${themeStyles.main.textHeadingColor}`}>
                                        Comments
                                    </span>
                                    {
                                        saveCommentsValue && (
                                            <div className="mt-[16px]">
                                                {
                                                    saveCommentsValue?.map((item: CommentType) => {
                                                        return (
                                                            <AddComments
                                                                id={item.id}
                                                                userName={item.userName}
                                                                createdDate={item.createdDate}
                                                                notes={item.notes}
                                                                deleteTheComment={(id) => deleteTheComment(id)}
                                                            />
                                                        );
                                                    })
                                                }
                                            </div>
                                        )
                                    }

                                    <form onSubmit={(e) => saveComment(e)} className="mt-2">
                                        <textarea
                                            className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            rows={6}
                                            value={comments}
                                            onChange={(e) => setComments(e.target.value)}
                                        />
                                        <div className="mt-6">
                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.main.bg
                                                }}
                                                type="submit"
                                            >
                                                Save
                                            </Button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>

            <DateAndTimeChange
                dateAndTimeBox={dateAndTimeBox}
                setDateAndTimeBox={(value) => setDateAndTimeBox(value)}
                pickupDate={pickupDate}
                pickupTime={pickupTime}
                returnDate={returnDate}
                returnTime={returnTime}
                getDataFromDate={(
                    pickupDate,
                    pickupTime,
                    returnDate,
                    returnTime,
                    alertMessage
                ) =>
                    getDataFromDatesSummaryPopup(
                        pickupDate,
                        pickupTime,
                        returnDate,
                        returnTime,
                        alertMessage
                    )
                }
                reservationId={primaryKey}
                preferredDateFormat={dateFormat}
                locationOpenHourOfParticularBranch={locationOpenHourOfParticularBranch}
                branches={branches}
                branchId={branchId}
                selectedVehicleClassId={vehicleClassId}
                setAvailableVehicle={setAvailableVehicle}
                setPleaseWait={setPleaseWaitPopup}
            />

            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    )
}